import { createContext, useMemo, useState } from "react";

export const ContextGenericGlobal = createContext([]);

export const GenericGlobal = ({children}) => {
    const [freight, setFreight] = useState(false);

    const contextMemo = useMemo(() => ({
        freight,
        setFreight
    }), [freight, setFreight])


    return (
        <ContextGenericGlobal.Provider value={contextMemo}> 
            {children}
        </ContextGenericGlobal.Provider>
    )
}